import React, { useState } from 'react'
import ButtonElement from 'pobble-components/dist/button-element'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil'
import { faCopy } from '@fortawesome/pro-solid-svg-icons/faCopy'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash'
import { faColumns } from '@fortawesome/pro-solid-svg-icons/faColumns'
import { faLineColumns } from '@fortawesome/pro-solid-svg-icons/faLineColumns'
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage'
import { faPalette } from '@fortawesome/pro-solid-svg-icons/faPalette'
import {
  deleteSlide,
  duplicateSlide,
  updateSlideImmediately
} from '../../../../../stores/presentation/presentation.actions'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import { openEditSlideDialog } from '../redux/builder.actions'
import injectSheet from 'react-jss'
import { useDispatch } from 'react-redux'
import ImageDialog from '../../../../presentation-wizard/image-slide/image-dialog/image-dialog.container'
import { backgroundColorsList } from 'pobble-components/dist/presentation'
import posthog from 'posthog-js'
import { apiClient } from 'pobble-components/dist/api'

const nextItemInArray = (array, item) => {
  const index = array.indexOf(item)
  if (index === -1) {
    return null
  }
  return array[index + 1] || array[0]
}

const layouts = [
  'left-fit',
  'right-fit',
  'center-fit',
  'left-fill',
  'right-fill',
  'center-fill'
]

const lines = [
  'guides-medium',
  'lines-medium',
  'blank-medium',
  'guides-large',
  'lines-large',
  'guides-narrow',
  'lines-narrow'
]

export const EditSlidePanel = injectSheet({
  quickActions: {
    border: '1px solid var(--gray)',
    display: 'flex',
    alignItems: 'flex-end',
    padding: '0',
    margin: '0',
    background: 'var(--gray)',
    listStyle: 'none',
    borderRadius: '24px',
    overflow: 'hidden',
    '& li': {
      borderLeft: '1px solid var(--gray-)',
      '&:first-child': {
        borderLeft: 'none'
      }
    },
    '& button': {
      display: 'flex',
      padding: '12px 24px',
      alignItems: 'center',
      justifyContent: 'center',
      font: 'var(--font-body-)',
      fontWeight: 'bold',
      color: 'var(--light-gray)',
      height: '40px',
      width: '40px',
      '&:hover': {
        background: '#000'
      },
      '& svg': {
        opacity: '.6',
        font: 'var(--font-body--)'
      }
    }
  },
  titleButton: {
    paddingLeft: '16px !important',
    width: 'auto !important',
    '& svg': {
      marginRight: '8px'
    }
  }
})(({ classes, slideData }) => {
  const dispatch = useDispatch()
  const [imageDialogOpened, setImagedialogOpened] = useState(false)

  return (
    <>
      <ul className={classes.quickActions}>
        {slideData.type === 'Blank' && (
          <li>
            <ButtonElement
              className={classes.titleButton}
              onClick={() => {
                const linesVariation =
                  nextItemInArray(
                    lines,
                    `${slideData.line_type}-${slideData.line_height}`
                  ) || 'guides-medium'
                dispatch(
                  updateSlideImmediately(slideData.id, 'Blank', {
                    line_type: linesVariation.split('-')[0],
                    line_height: linesVariation.split('-')[1]
                  })
                ).catch(errorHandler)
              }}>
              <FontAwesomeIcon icon={faLineColumns} />
              <span>Change line type</span>
            </ButtonElement>
          </li>
        )}
        {(slideData.type === 'Title' || slideData.type === 'Image') && (
          <li>
            <ButtonElement
              className={classes.titleButton}
              onClick={() => {
                setImagedialogOpened(true)
              }}>
              <FontAwesomeIcon icon={faImage} />
              <span>Change image</span>
            </ButtonElement>
          </li>
        )}
        {slideData.type !== 'Blank' && (
          <li>
            <ButtonElement
              className={classes.titleButton}
              onClick={() => {
                apiClient.post('/v3/me/activated_with_product', {
                  type: 'feature'
                })
                posthog.capture('activate', { type: 'feature' })
                posthog.capture('click on edit content from builder', {
                  slide_type: slideData.type
                })
                dispatch(openEditSlideDialog(slideData.type, slideData.id))
              }}>
              <FontAwesomeIcon icon={faPencil} />
              <span>Edit content</span>
            </ButtonElement>
          </li>
        )}
        {(slideData.type === 'Text' || slideData.type === 'Exercise') && (
          <li>
            <ButtonElement
              className={classes.titleButton}
              onClick={() => {
                const color =
                  nextItemInArray(
                    backgroundColorsList,
                    slideData.secondaryColor
                  ) || 'sqyi'
                dispatch(
                  updateSlideImmediately(slideData.id, null, {
                    secondaryColor: color
                  })
                ).catch(errorHandler)
              }}>
              <FontAwesomeIcon icon={faPalette} />
              <span>Change color</span>
            </ButtonElement>
          </li>
        )}
        {slideData.type === 'Image' && (
          <li>
            <ButtonElement
              className={classes.titleButton}
              onClick={() => {
                const layout = nextItemInArray(
                  layouts,
                  `${slideData.imagePosition}-${slideData.image_size}`
                )
                dispatch(
                  updateSlideImmediately(slideData.id, 'Image', {
                    imagePosition: layout.split('-')[0],
                    image_size: layout.split('-')[1]
                  })
                )
              }}>
              <FontAwesomeIcon icon={faColumns} />
              <span>Change layout</span>
            </ButtonElement>
          </li>
        )}
        {slideData.type !== 'Title' &&
          slideData.type !== 'LessonOverview' && (
            <li>
              <ButtonElement
                title="Duplicate slide"
                onClick={() => {
                  openConfirmationDialog({
                    bodyText: 'Are you sure you want to duplicate this slide?',
                    action: () =>
                      dispatch(duplicateSlide(slideData.id)).catch(
                        errorHandler
                      ),
                    confirmText: 'Duplicate',
                    cancelText: 'Cancel'
                  })
                }}>
                <FontAwesomeIcon icon={faCopy} />
              </ButtonElement>
            </li>
          )}

        {slideData.type !== 'Title' && (
          <li>
            <ButtonElement
              title={slideData.hidden ? 'Show slide' : 'Hide slide'}
              onClick={() => {
                openConfirmationDialog({
                  bodyText: `Are you sure you want to ${
                    slideData.hidden ? 'show' : 'hide'
                  } this slide?`,
                  action: () =>
                    dispatch(
                      updateSlideImmediately(slideData.id, null, {
                        hidden: !slideData.hidden
                      })
                    ).catch(errorHandler),
                  confirmText: slideData.hidden ? 'Show' : 'Hide',
                  cancelText: 'Cancel'
                })
              }}>
              <FontAwesomeIcon icon={slideData.hidden ? faEye : faEyeSlash} />
            </ButtonElement>
          </li>
        )}
        {slideData.type !== 'Title' &&
          slideData.type !== 'LessonOverview' && (
            <li>
              <ButtonElement
                title="Delete slide"
                onClick={() => {
                  openConfirmationDialog({
                    bodyText: 'Are you sure you want to delete this slide?',
                    action: () =>
                      dispatch(deleteSlide(slideData.id)).catch(errorHandler),
                    theme: 'danger',
                    confirmText: 'Delete',
                    cancelText: 'Cancel'
                  })
                }}>
                <FontAwesomeIcon icon={faTrash} />
              </ButtonElement>
            </li>
          )}
      </ul>
      <ImageDialog
        onClose={() => setImagedialogOpened(false)}
        isOpen={imageDialogOpened}
        id={slideData.id}
      />
    </>
  )
})
